import { render } from "./transaction-component.vue?vue&type=template&id=995c0854&ts=true"
import script from "./transaction-component.vue?vue&type=script&lang=ts"
export * from "./transaction-component.vue?vue&type=script&lang=ts"

import "./transaction-component.vue?vue&type=style&index=0&id=995c0854&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__